// import logo from './logo.svg';
import './App.css';

import { Route, Routes } from 'react-router';
import Header from './core/Header';
import Footer from './core/Footer';
import Home from './components/Home';
import Archive from './components/Archive';
import TextBook from './components/TextBook';
import Team from './components/Team';
import About from './components/About';
import NotFound from './core/NotFound'
import AllForms from './components/forms/AllForms';
import Kaleidoskop from './components/Kaleidoskop';
import Impressum from './components/Impressum';
import ForcedLabourDetailPage from './core/ForcedLabourDetailPage';

function App() {
  return (

    <>

      <div className='App'>
      <header>
        <Header />
      </header>

      <main>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='kaleidoskop' element={<Kaleidoskop />} />
          <Route path='archive' element={<Archive />} />
          <Route path='textbook' element={<TextBook />} />
          <Route path='team' element={<Team />} />
          <Route path='about' element={<About />} />
          <Route path='archive/details' element={<ForcedLabourDetailPage />} />

          <Route path='*' element={<NotFound/>}/>


          <Route path='impressum' element={<Impressum />} />
          <Route path='inputs' element={<AllForms />} />
        </Routes>

      </main>



      <footer>
        <Footer />
      </footer>

      </div>


      


    </>

  );
}

export default App;
